import io from 'socket.io-client';



// eslint-disable-next-line import/no-mutable-exports
let client = null;



function initializeClient() {
  client = io({ transports: ['websocket'] });
}



// window.testDisconnect = function () {
//   client.disconnect();
// };
// window.testReconnect = function () {
//   client.connect();
// };
// console.warn('test methods are active in socket-io-client.js');



export { client, initializeClient };
